module.exports = __webpack_public_path__ + "static/media/pinterest-p.7f6ea8ed.svg";